import React from "react";
import { MenuType } from "../../../types/baseTypes";
import { CustomLink } from "../../Global/CustomLink";
import styles from "./FooterMenu.module.scss";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

function FooterMenu({
  menu,
  headline,
  openCookieSettings,
  extraClass,
}: {
  menu?: MenuType;
  headline: string;
  openCookieSettings: () => void;
  extraClass?: string;
}) {
  const { items } = menu || {};
  const { getLabel } = useGlobalContext();

  if (items == null) return null;

  return (
    <div className={`${styles["footer-menu"]}  ${extraClass}`}>
      {headline && (
        <span className="footer-headline h3 is-block">{headline}</span>
      )}

      {items.map((item, index) => {
        if (item.classes.includes("cookie-button")) {
          return (
            <button
              key={`cookie-menu-${index}`}
              className={`${styles["cookie-button"]} footer-link`}
              onClick={openCookieSettings}
              aria-label={getLabel("aria_footer_cookie_settings")}
            >
              {item.title}
            </button>
          );
        }

        return (
          <CustomLink
            key={`footer-menu-${index}`}
            href={item.url}
            target={item.target}
            className="footer-link"
            id={`menuitem-${index}`}
            disablePrefetch // Disable prefetching for footer links https://trello.com/c/g5k075FS
          >
            {item.title}
          </CustomLink>
        );
      })}
    </div>
  );
}

export default FooterMenu;
